<script>
import TablePage from '../../../../../../../components/table_page';
import TotalAdjust from '../total_adjust.vue';

export default {
  extends: TablePage,
  components: {
    TotalAdjust,
  },
  props: {
    poolCode: String,
    conditionInfo: Object,
    operationType: String,
  },
  data() {
    return {
      requestUrl: '',
      params: { },
      formConfig: {},
      selection: [],
      modalConfig: {
        title: '新增',
        visible: false,
        type: 'Modal',
      },
    };
  },
  watch: {
    operationType(n) {
      this.params.operationType = n;
      this.getList();
    },
  },
  created() {
    this.params.poolCode = this.poolCode;
    if (this.poolCode) {
      this.isCalculateHeight = false;
    }
    this.getConfigList('fee_pool_detail_log');
  },
  methods: {
    setColumn(v) {
      const rowData = v;
      if (rowData.field === 'fileList') {
        rowData.type = 'html';
        rowData.formatter = ({ cellValue }) => {
          if (cellValue && cellValue.length > 0) {
            const list = [];
            cellValue.forEach((val) => {
              list.push(`<a href=${val.url}>${val.fileName}</a>`);
            });
            return list.join(',');
          }
          return '';
        };
      }
      return rowData;
    },
    modalClick({ val, row }) {
      if (val.code === 'dms_thaw') {
        this.modalConfig.title = '解冻';
        this.formName = 'TotalAdjust';
        this.formConfig.btnCode = 'thaw';
        const rowData = {
          ...row.rebateFeePoolVo,
          unfrozenFee: row.unfrozenFee,
          frozenFee: row.frozenFee,
          rebateFeePoolFrozenItemCode: row.code,
          files: row.files,
        };
        this.formConfig.selectRow = [rowData];
        this.openFull();
      } else if (val.code === 'view') {
        this.modalConfig.title = '查看';
        this.formName = 'TotalAdjust';
        this.formConfig.btnCode = val.code;
        this.formConfig.code = val.code;
        const rowData = {
          ...row.rebateFeePoolVo,
          unfrozenFee: row.unfrozenFee,
          frozenFee: row.frozenFee,
          rebateFeePoolFrozenItemCode: row.code,
          files: row.files,
        };
        this.formConfig.selectRow = [rowData];
        this.openFull();
      }
    },
  },
};
</script>
